import {
  NEIGHBORHOOD_BOUNDARY_COLOR,
  FULL_LOSS_COLOR,
  PARTIAL_LOSS_COLOR,
} from "./MapStyles";

export const Legend = () => (
  <div className="map-overlay legend mixed">
    <p className="slider-legend-title">Registered in 2019, but...</p>
    <p className="slider-legend-title">
      <svg width="16" height="16" transform="translate(0,4)">
        <circle fill={FULL_LOSS_COLOR} cx="8" cy="8" r="6"></circle>
      </svg>{" "}
      didn't register in 2022
    </p>
    <p className="slider-legend-title">
      <svg width="16" height="16" transform="translate(0,4)">
        <circle fill={PARTIAL_LOSS_COLOR} cx="8" cy="8" r="6"></circle>
      </svg>{" "}
      registered fewer units in 2022
    </p>
    <p className="slider-legend-title">
      <span style={{ color: NEIGHBORHOOD_BOUNDARY_COLOR }}>|–</span>{" "}
      neighborhood boundaries
    </p>
  </div>
);
